import { render, staticRenderFns } from "./UpgradeBanner.vue?vue&type=template&id=bd199158&scoped=true"
import script from "./UpgradeBanner.vue?vue&type=script&lang=js"
export * from "./UpgradeBanner.vue?vue&type=script&lang=js"
import style0 from "./UpgradeBanner.vue?vue&type=style&index=0&id=bd199158&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd199158",
  null
  
)

export default component.exports